import React from 'react';
import styled, { keyframes } from 'styled-components';
import { prop } from 'styled-tools';

/*
 * Styles
 */

const CircleIn = keyframes`
  0% {
    opacity: 0;
  }
`;

const Circle = styled.circle`
  animation: ${CircleIn} 900ms 1800ms ${prop('theme.settings.easings.quintOut')} 1 backwards};
  fill: white
  stroke: ${prop('theme.colors.orange')};
  stroke-width: 2px
  &:nth-of-type(3n + 1) {
    animation-delay: 1950ms;
  }
  &:nth-of-type(3n + 2) {
    animation-delay: 2100ms;
  }
  &:nth-of-type(3n + 3) {
    animation-delay: 2250ms;
  }
`;

/*
 * Components
 */

const HaloPlotPoints = (props) => {
  const { arcAngleCentroid, arcRadius, data, pointRadius } = props;

  return (
    data.map((d, i) => {
      return(
        <Circle
          key={i}
          r={pointRadius}
          cx={arcRadius(d) * Math.cos(arcAngleCentroid(i) - Math.PI * 0.5)}
          cy={arcRadius(d) * Math.sin(arcAngleCentroid(i) - Math.PI * 0.5)}
        >
        </Circle>
      )
    })
  )
};

export default HaloPlotPoints;
